import {Inject, Injectable} from "@angular/core";
import {EventManager} from "@angular/platform-browser";
import {DOCUMENT} from "@angular/common";
import {Observable} from "rxjs";

type Options = {
    element: any;
    keys: string;
}

@Injectable({providedIn: 'root'})
export class HotkeyService {
    hotkeys = new Map();
    defaults: Partial<Options> = {}

    constructor(
        private eventManager: EventManager,
        @Inject(DOCUMENT) private document: Document,
    ) {
        this.defaults = {
            element: this.document
        }
    }

    addShortcut(options: Partial<Options>) {
        const merged = {...this.defaults, ...options};
        const event = `keydown.${merged.keys}`;

        return new Observable(observer => {
            const handler = (e: KeyboardEvent) => {
                const target = e.target as HTMLElement;

                // Don't trigger shortcut inside input fields, textareas, or contentEditable elements
                if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
                    return;
                }

                e.preventDefault();
                observer.next(e);
            };

            const dispose = this.eventManager.addEventListener(
                merged.element, event, handler
            );

            return () => {
                dispose();
                this.hotkeys.delete(merged.keys);
            };
        })
    }
}
